import { Check, Delete, Edit, Refresh, Sync } from '@mui/icons-material';
import {
  Button,
  Card,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { manageAffiliateTag, updateProductTags } from '../../api/products';
import { tagFields } from '../../staticData/tableHead';
import ListHead from '../elements/table/ListHead';
import DeleteTag from './deleteTag';

const ListTags = ({
  data,
  setSnackbarOpen,
  setSnackbarMessage,
  fetchData,
  token,
  setError,
}) => {
  const [formData, setFormData] = useState({
    store: '',
    value: '',
  });
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');
  const [editingRowId, setEditingRowId] = useState(null);
  const [editingValues, setEditingValues] = useState({});

  const handleRequestSort = (property) => {
    if (property === 'name') {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleRowInputChange = (e, fieldName) => {
    const { value } = e.target;
    setEditingValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };

  const handleSubmitForm = async (type, id, values) => {
    const payload = {
      tag: {
        ...formData,
        ...values,
        store: values?.store?.toLowerCase() || formData?.store.toLowerCase(),
        type: type,
        id: id,
      },
    };
    try {
      const response = await manageAffiliateTag(payload, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setSnackbarMessage('Tags updated successfully');
      fetchData();
      setEditingRowId(null);
      setEditingValues({});
    } catch (error) {
      setError(error.message || 'An error occurred while updating tags.');
    }
  };

  const handleEditClick = (row) => {
    setEditingRowId(row.id);
    setEditingValues({
      store: row.store,
      value: row.value,
    });
  };

  const handleSaveClick = (id) => {
    handleSubmitForm('update', id, editingValues);
  };

  const handleUpdateProducts = async () => {
    try {
      const response = await updateProductTags(token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setSnackbarMessage('Tags updated successfully');
      fetchData();
      setEditingRowId(null);
      setEditingValues({});
    } catch (error) {
      setError(error.message || 'An error occurred while updating tags.');
    }
  };

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          Affiliate Tags
        </Typography>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            title="Sync"
            onClick={handleUpdateProducts}>
            <Sync />
          </Button>
        </Grid>
      </Stack>
      <Card>
        <Grid container spacing={2} padding={2} xs={8}>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Store"
              id="store"
              type="text"
              value={formData.store}
              name="store"
              fullWidth
              placeholder="Store"
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Value"
              id="value"
              type="text"
              value={formData.value}
              name="value"
              fullWidth
              placeholder="Value"
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm="auto" alignSelf="center">
            <Button
              variant="contained"
              color="primary"
              disabled={!formData.store || !formData.value}
              onClick={() => {
                handleSubmitForm('add');
              }}>
              Add
            </Button>
          </Grid>
        </Grid>
        <TableContainer sx={{ minWidth: 600 }}>
          <Table>
            <ListHead
              order={order}
              orderBy={orderBy}
              headLabel={tagFields}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data &&
                data.map((row, index) => (
                  <tr key={'row' + index}>
                    {tagFields.map((column) => {
                      return column.id === 'actions' ? (
                        <TableCell key={'action' + index} align="center">
                          {editingRowId === row.id ? (
                            <Button
                              onClick={() => handleSaveClick(row.id)}
                              title="Save">
                              <Check />
                            </Button>
                          ) : (
                            <Button
                              onClick={() => handleEditClick(row)}
                              title="Edit">
                              <Edit />
                            </Button>
                          )}

                          <DeleteTag
                            data={row}
                            fetchData={fetchData}
                            token={token}
                            handleSubmit={handleSubmitForm}
                          />
                        </TableCell>
                      ) : (
                        <TableCell
                          key={row[column.id]}
                          align="center"
                          width="300px">
                          {editingRowId === row.id &&
                          column.id !== 'actions' && column.id !== 'sno' ? (
                            <TextField
                              size="small"
                              style={{ padding: '5px' }}
                              name={column.id}
                              value={editingValues[column.id] || ''}
                              onChange={(e) =>
                                handleRowInputChange(e, column.id)
                              }
                            />
                          ) : (
                            row[column.id]
                          )}
                        </TableCell>
                      );
                    })}
                  </tr>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  );
};

export default ListTags;
